export type NormalizedHalalStatus =
  | "halal"
  | "doubtful"
  | "not_halal"
  | "unqualified"
  | "unknown";

export function normalizeHalalStatus(raw?: string | null): NormalizedHalalStatus {
  if (!raw?.trim()) return "unknown";
  const s = raw.toLowerCase().trim().replace(/_/g, "-");
  if (s === "halal") return "halal";
  if (s === "doubtful") return "doubtful";
  if (s === "not-halal" || s === "not halal") return "not_halal";
  if (s === "unqualified" || s === "unrated") return "unqualified";
  return "unknown";
}
